// `react_csr` = measured after a client-side navigation, not rendered on the client: every migrated
// route is server-rendered on load.
export type TRenderType = 'react_ssr' | 'react_csr'

const initialPathname = typeof window === 'undefined' ? null : window.location.pathname

let hasSoftNavigated = false

export const trackNavigation = (pathname: string): void => {
    if (initialPathname !== null && pathname !== initialPathname) {
        hasSoftNavigated = true
    }
}

export const getRenderType = (): TRenderType => {
    const isSoftNavigation =
        hasSoftNavigated ||
        (initialPathname !== null && window.location.pathname !== initialPathname)

    return isSoftNavigation ? 'react_csr' : 'react_ssr'
}
